module.exports = __webpack_public_path__ + "static/media/IntroToAndroid.38f82379.png";